import React from 'react';
import { FeatureGridIcon } from './FeatureGridIcon';
import {
  type FeatureItemIcon,
  resolveFeatureIconDisplay,
} from '../utils/featuresGridUtils';

export const FeatureIconVisual: React.FC<{
  feature: FeatureItemIcon;
  size?: number;
  emojiFontSize?: number;
}> = ({ feature, size = 28, emojiFontSize }) => {
  const display = resolveFeatureIconDisplay(feature);
  if (!display) return null;

  if (display.kind === 'image') {
    return (
      <img
        src={display.url}
        alt=""
        style={{
          width: size,
          height: size,
          objectFit: 'contain',
          display: 'block',
        }}
      />
    );
  }

  if (display.kind === 'pack') {
    return <FeatureGridIcon iconKey={display.key} size={size} />;
  }

  return (
    <span style={{ fontSize: emojiFontSize ?? size, lineHeight: 1, display: 'inline-block' }}>
      {display.text}
    </span>
  );
};
